import React from "react";
import { useSelector } from "react-redux";
import { Row, Select, Col, Space, InputNumber, Button } from "antd";
import { FormattedMessage } from "react-intl";
import { useSearchParams, useParams } from "react-router-dom";

import store from "../../../store";
import MQTTService from "../../../services/mqtt";

import { MESSAGE_TYPE } from "../../../lib/utils/constants";

import { actions as NODE_ACTIONS, selectors as NODE_SELECTORS } from "../../../ducks/node";

const VMAF = () => {
  const vmafModels = useSelector(NODE_SELECTORS.getNodeAnalyticsVMAFModels);
  const nodeAnalytics = useSelector(NODE_SELECTORS.getNodeAnalytics);
  const { cwid } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const vmafModelsOptions = vmafModels.map((model) => ({
    label: model,
    value: model,
  }));
  const modelName = searchParams.get("vmafm") || vmafModelsOptions[0].value;
  const duration = searchParams.get("dur") || 2;
  const channelId = searchParams.get("c");
  const outputId = searchParams.get("o");
  const testType = searchParams.get("tabt") || (nodeAnalytics && nodeAnalytics.length > 0 ? nodeAnalytics[0] : "");

  const isDisabled = !channelId || !outputId || !testType || !modelName || !duration;

  const handleChangeVMAFModel = (selectedVMAFModel) => {
    searchParams.set("vmafm", selectedVMAFModel);
    setSearchParams(searchParams);
  };

  const handleChangeDuration = (value) => {
    searchParams.set("dur", value);
    setSearchParams(searchParams);
  };

  const handleStartTest = () => {
    store.dispatch(NODE_ACTIONS.SET_NODE_TEST_STARTED(true));
    MQTTService.sendMessageV5({
      topic: `node/${cwid}/in`,
      message: {
        msgType: MESSAGE_TYPE.START_TEST,
        channelId,
        testType,
        duration,
        params: {
          modelName,
          outputId,
        },
      },
    });
  };

  return (
    <Row gutter={[24, 24]}>
      <Col sm={24} md={12} lg={5}>
        <Space>
          <FormattedMessage id="NodeAnalytics.vmafModel" defaultMessage="Model" />
          <Select
            options={vmafModelsOptions}
            onChange={handleChangeVMAFModel}
            showSearch
            optionFilterProp="label"
            style={{ minWidth: 150 }}
            value={modelName}
          />
        </Space>
      </Col>
      <Col sm={24} md={12} lg={4}>
        <Space>
          <FormattedMessage id="NodeAnalytics.duration" defaultMessage="Duration" />
          <InputNumber
            addonAfter="[s]"
            min={1}
            max={1000}
            onChange={handleChangeDuration}
            value={duration}
            defaultValue={5}
            style={{ width: 100 }}
          />
        </Space>
      </Col>
      <Col>
        <Button type="primary" disabled={isDisabled} onClick={handleStartTest}>
          <FormattedMessage id="NodeAnalytics.runTest" defaultMessage="Run test" />
        </Button>
      </Col>
    </Row>
  );
};

export default VMAF;
